import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { environment } from '../../../../environments/environment';
import { Stage } from '../../shared/enums/stage.enum';
import { ApplicationSettings } from '../../shared/models/application-settings.model';
import { AppSettings } from './settings.action';

// On PROD the environment hint should not be visible initially
const showEnvironmentHintDefaultValue = environment.stage === Stage.PROD ? false : true;

@State<ApplicationSettings>({
    name: 'app_settings',
    defaults: {
        showEnvironmentHint: showEnvironmentHintDefaultValue
    }
})
@Injectable()
export class ApplicationState {
    @Action(AppSettings.update)
    public update(ctx: StateContext<ApplicationSettings>, action: AppSettings.update): void {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            ...action.data
        });
    }

    @Selector()
    public static getSettings(state: ApplicationSettings): ApplicationSettings {
        return state;
    }

    @Selector()
    public static getShowEnvironmentHint(state: ApplicationSettings): boolean {
        return state.showEnvironmentHint;
    }
}
